import RestClient from '../RestClient/RestClient';

export const getUrgencyStatements = (ppid, apiURL) => {
    let url = `${apiURL}/${ppid}?channel=MWEB`;
    if (Array.isArray(ppid)) {
        const ppidValue = ppid.join(',');
        url = `${apiURL}?productId=${ppidValue}`;
    }
    const config = {
        url,
        external: true,
        credentials: 'same-origin',
    };
    /* istanbul ignore next */
    return RestClient.get(config)
        .then((json) => json.data)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
